if (Shopify.theme_settings.show_multiple_currencies) {
  Shopify.theme.convertCurrency = function () {

  if (Shopify.theme_settings.currency_format !== '') {
    Currency.format = Shopify.theme_settings.currency_format;
  }

  console.log(Currency.format);

    var shopCurrency = Shopify.theme_settings.currency;

    console.log(shopCurrency)

    /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
    Currency.money_with_currency_format[shopCurrency] = Currency.shop_money_with_currency_format;
    Currency.money_format[shopCurrency] = Currency.shop_money_format;

    /* Default currency */
    var defaultCurrency = Shopify.theme_settings.currency_format || shopCurrency;

    // Currency selector
    let $currencySelector = $("[data-currency-converter]");

    // Save current price
    $('span.money').each(function () {
      $(this).attr('data-currency-' + shopCurrency, $(this).html());
    });

    console.log(defaultCurrency);

    // Saved Cookie currency
    let cookieCurrency = Currency.cookie.read();

    if (cookieCurrency == null) {
      console.log('no cookie');
      // No currency cookie has been stored
      if (shopCurrency !== defaultCurrency) {
        Currency.convertAll(shopCurrency, defaultCurrency);
      }
      else {
        Currency.currentCurrency = defaultCurrency;
      }

      $currencySelector.val(defaultCurrency);
    }
    else if ($currencySelector.length && $currencySelector.find('option[value=' + cookieCurrency + ']').length === 0) {
      // If the cookie value does not correspond to any value in the currency dropdown.
      Currency.currentCurrency = shopCurrency;
      Currency.cookie.write(shopCurrency);
      $currencySelector.val(Currency.currentCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
      Currency.currentCurrency = shopCurrency;
      $currencySelector.val(Currency.currentCurrency);
    }
    else {
    //Currency.convertAll(shopCurrency, cookieCurrency);
      $currencySelector.val(Currency.currentCurrency);
    }

    $currencySelector.val(Currency.currentCurrency).change(function () {
      let newCurrency = $(this).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
    });

    if ($currencySelector.val() && $currencySelector.val() != $currencySelector.data('default-shop-currency')) {
      Currency.convertAll($currencySelector.data('default-shop-currency'), $currencySelector.val());
      $('.selected-currency').text(Currency.currentCurrency);
    }
  }
}

/*============================================================================
Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.theme.updateOptionsInSelector = function (selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
    var key = 'root';
    var selector = $(parent + ' .single-option-selector:eq(0)');
    break;
    case 1:
    var key = $(parent + ' .single-option-selector:eq(0)').val();
    var selector = $(parent + ' .single-option-selector:eq(1)');
    break;
    case 2:
    var key = $(parent + ' .single-option-selector:eq(0)').val();
    key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
    var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });

};

Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  Shopify.optionsMap = {};
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.theme.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) Shopify.theme.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) Shopify.theme.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(parent + " .single-option-selector:eq(0)").change(function () {
    Shopify.theme.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.theme.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(parent + " .single-option-selector:eq(1)").change(function () {
    if (product.options.length === 3) Shopify.theme.updateOptionsInSelector(2, parent);
    return true;
  });
};

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/* option_selection.js */
function floatToString(t, e) { var o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? "0" + o : o } if ("undefined" == typeof Shopify) var Shopify = {}; Shopify.each = function (t, e) { for (var o = 0; o < t.length; o++)e(t[o], o) }, Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o }, Shopify.arrayIncludes = function (t, e) { for (var o = 0; o < t.length; o++)if (t[o] == e) return !0; return !1 }, Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e }, Shopify.isDefined = function (t) { return "undefined" == typeof t ? !1 : !0 }, Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1) }, Shopify.extend = function (t, e) { function o() { } o.prototype = e.prototype, t.prototype = new o, t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype }, Shopify.locationSearch = function () { return window.location.search }, Shopify.locationHash = function () { return window.location.hash }, Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t) }, Shopify.urlParam = function (t) { var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, " ")) }, Shopify.newState = function (t, e) { var o; return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash() }, Shopify.setParam = function (t, e) { Shopify.replaceState(Shopify.newState(t, e)) }, Shopify.Product = function (t) { Shopify.isDefined(t) && this.update(t) }, Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property] }, Shopify.Product.prototype.optionNames = function () { return "Array" == Shopify.getClass(this.options) ? this.options : [] }, Shopify.Product.prototype.optionValues = function (t) { if (!Shopify.isDefined(this.variants)) return null; var e = Shopify.map(this.variants, function (e) { var o = "option" + (t + 1); return void 0 == e[o] ? null : e[o] }); return null == e[0] ? null : Shopify.uniq(e) }, Shopify.Product.prototype.getVariant = function (t) { var e = null; return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) { for (var i = !0, r = 0; r < t.length; r++) { var n = "option" + (r + 1); o[n] != t[r] && (i = !1) } return 1 == i ? void (e = o) : void 0 }), e) }, Shopify.Product.prototype.getVariantById = function (t) { for (var e = 0; e < this.variants.length; e++) { var o = this.variants[e]; if (t == o.id) return o } return null }, Shopify.money_format = "$", Shopify.formatMoney = function (t, e) { function o(t, e) { return "undefined" == typeof t ? e : t } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0; t = (t / 100).toFixed(e); var n = t.split("."), a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i), s = n[1] ? r + n[1] : ""; return a + s } "string" == typeof t && (t = t.replace(".", "")); var r = "", n = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format; switch (a.match(n)[1]) { case "amount": r = i(t, 2); break; case "amount_no_decimals": r = i(t, 0); break; case "amount_with_comma_separator": r = i(t, 2, ".", ","); break; case "amount_with_apostrophe_separator": r = i(t, 2); break; case "amount_no_decimals_with_comma_separator": r = i(t, 0, ".", ",") }return a.replace(n, r) }, Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () { }, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0 }, Shopify.OptionSelectors.prototype.initDropdown = function () { var t = { initialLoad: !0 }, e = this.selectVariantFromDropdown(t); if (!e) { var o = this; setTimeout(function () { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t) }) } }, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t) }, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { var e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t) }, Shopify.OptionSelectors.prototype.replaceSelector = function (t) { var e = document.getElementById(t), o = e.parentNode; Shopify.each(this.buildSelectors(), function (t) { o.insertBefore(t, e) }), e.style.display = "none", this.variantIdField = e }, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { var e = document.getElementById(this.domIdPrefix).querySelector("[selected]"); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; var o = e.value; return this.selectVariant(o, t) }, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { var e = Shopify.urlParam("variant"); return this.selectVariant(e, t) }, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { var o = this.product.getVariantById(t); if (null == o) return !1; for (var i = 0; i < this.selectors.length; i++) { var r = this.selectors[i].element, n = r.getAttribute("data-option"), a = o[n]; null != a && this.optionExistInSelect(r, a) && (r.value = a) } return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0 }, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (var o = 0; o < t.options.length; o++)if (t.options[o].value == e) return !0 }, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector"; var o = document.getElementById(t); Shopify.each(this.buildSelectors(), function (t) { o.appendChild(t) }) }, Shopify.OptionSelectors.prototype.buildSelectors = function () { for (var t = 0; t < this.product.optionNames().length; t++) { var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e) } var o = this.selectorDivClass, i = this.product.optionNames(), r = Shopify.map(this.selectors, function (t) { var e = document.createElement("div"); if (e.setAttribute("class", o), i.length > 1) { var r = document.createElement("label"); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r) } return e.appendChild(t.element), e }); return r }, Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { var o = this.selectors[e].element.value; t.push(o) } return t }, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { var o = this.selectedValues(), i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e) }, Shopify.OptionSelectorsFromDOM = function (t, e) { var o = e.optionNames || [], i = e.priceFieldExists || !0, r = e.delimiter || "/", n = this.createProductFromSelector(t, o, i, r); e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e) }, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) { if (!Shopify.isDefined(o)) var o = !0; if (!Shopify.isDefined(i)) var i = "/"; var r = document.getElementById(t), n = r.childNodes, a = (r.parentNode, e.length), s = []; Shopify.each(n, function (t, r) { if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) { var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*")); 0 == e.length && (a = n.length - (o ? 1 : 0)); var p = n.slice(0, a), l = o ? n[a] : "", c = (t.getAttribute("value"), { available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2] }); s.push(c) } }); var p = { variants: s }; if (0 == e.length) { p.options = []; for (var l = 0; a > l; l++)p.options[l] = "option " + (l + 1) } else p.options = e; return p }, Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select"); for (var r = 0; r < i.length; r++) { var n = document.createElement("option"); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n) } return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i) }, !0 }, Shopify.Image = { preload: function (t, e) { for (var o = 0; o < t.length; o++) { var i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)) } }, loadImage: function (t) { (new Image).src = t }, switchImage: function (t, e, o) { if (t && e) { var i = this.imageSize(e.src), r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r } }, imageSize: function (t) { var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return null != e ? e[1] : null }, getSizedImageUrl: function (t, e) { if (null == e) return t; if ("master" == e) return this.removeProtocol(t); var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (null != o) { var i = t.split(o[0]), r = o[0]; return this.removeProtocol(i[0] + "_" + e + r) } return null }, removeProtocol: function (t) { return t.replace(/http(s)?:/, "") } }, Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t) }, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener("popstate", function (e) { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }) }) }, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id)) }, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState };

selectCallback = function (variant, selector) {

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form, .shopify-product-form', $product);
  var variantInventory = $productForm.data('variant-inventory');


  var $notifyFormInputs = $('.notify_form__inputs');
  var notifyEmail = Shopify.translation.notify_form_email;
  var notifyEmailValue = Shopify.translation.contact_email;
  var notifySend = Shopify.translation.notify_form_send;

  var notifyUrl = $notifyFormInputs.data('url');

  if (variant) {
    var notifyMessage = Shopify.translation.message_content + variant.name + ' | ' + notifyUrl + '?variant=' + variant.id;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = Shopify.translation.customer_email;
    var notifyEmailInput = `
      <input type="hidden" class="notify_email input" name="contact[email]" id="contact[email]" value="${notifyCustomerEmail}" />`;
  } else {
    var notifyEmailInput = `
      <input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }

  var notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field has-addons">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`;

  //Image Variant feature
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.js-product-gallery, .js-gallery-modal', $product);
    $sliders.each(function () {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined) {
        var index = $('[data-image-id="' + variant.featured_image.id + '"]').data('index');
        $sliderInstance.select(index, false, true);
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function (v) {
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    if (Shopify.theme_settings.product_form_style) {
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g, '\\"') + '"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    } else {
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);
    }
  }

  if (variant && variant.available == true) {
    if (variant.price < variant.compare_at_price) {
      $('.was-price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.savings', $product).html(Shopify.translation.product_savings + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was-price', $product).html('');
      $('.savings', $product).html('');
      $('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (Shopify.theme_settings.display_inventory_left) {
        if (variant.inventory_quantity == 1) {
          items_left_text = Shopify.translation.product_count_one;
        } else {
          items_left_text = Shopify.translation.product_count_other;
        }

        var inventoryThreshold = Shopify.theme_settings.inventory_threshold;
        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(variant.inventory_quantity + " " + items_left_text);
        } else {
          $('.items_left', $product).html("");
        }
      }
      if (Shopify.theme_settings.limit_quantity) {
        if (variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      }
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');

    if (variant.price > 0) {
      $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
    } else {
      $('.current_price', $product).html(Shopify.translation.free_price_text);
    }

    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));

    $('.shopify-payment-button', $product).show();

    $notify_form.hide();
    $notifyFormInputs.empty();
  } else {
    var message = variant ? Shopify.translation.soldOut : Shopify.translation.unavailable;
    $('.was-price', $product).text('');
    $('.savings', $product).text('');
    $('.current_price', $product).text('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    $('.shopify-payment-button', $product).hide();
    $notify_form.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }

};

Shopify.theme.getSectionData = function($section){

  var $dataEl = $section.find('[data-section-data]').first();

  if (!$dataEl) return {};

  // Load data from attribute, or innerHTML
  var data = $dataEl.data('section-data') || $dataEl.html();

  try {
    return JSON.parse(data);
  } catch(error) {
    console.warn(`Sections: invalid section data found. ${error.message}`);
    return {};
  }
}

Shopify.theme.dropdownMenu = function () {

  const domElements = {
    $submenuInput: $('.has-submenu input')
  }

  domElements.$submenuInput.on('click', function () {
    if ($(this).hasClass('is-opened')) {
      let parentLink = $(this).closest('navbar-link').attr('href');
      window.location.href = parentLink;
    } else {
      $(this).addClass('is-opened');
    }
  })
}

